module.exports = __webpack_public_path__ + "img/pos-bridge-crossing.65f80d7b.png";